import { screenGte, useMediaQuery } from 'modules/media/use-media-query';
import * as yup from 'yup';

export function useSchema() {
  const isDesktop = useMediaQuery(screenGte.small);
  return {
    activeTab: yup.string().default(isDesktop ? 'Overview' : 'Main'),
    positionsActiveTab: yup.string(),
  };
}
